import { IWorkflowNode } from "motw_core/Entity/IWorkflowNode";
import * as React from "react";
import { DisplayFavoritesInfo } from "source/app/presentation/MainPanel/Workflows/SearchNodes/Favorites/DisplayFavoritesInfo";
import { SearchResult } from "source/app/presentation/MainPanel/Workflows/SearchNodes/SearchResult/SearchResult";
import * as styles from "source/app/presentation/MainPanel/Workflows/SearchNodes/SearchNodes.css";

export function SearchResults({
    showFavorites,
    filteredNodes,
    favoriteNodes,
}: {
    showFavorites: boolean;
    filteredNodes: IWorkflowNode[];
    favoriteNodes: IWorkflowNode[];
}) {
    const nodesToShow = showFavorites ? favoriteNodes : filteredNodes;

    return (
        <div
            id="searchResults"
            className={showFavorites ? styles.favoritesPanel : undefined}
        >
            <DisplayFavoritesInfo showFavorites={showFavorites} />
            {nodesToShow.map((node, index) => (
                <SearchResult
                    node={node}
                    key={index}
                    isFavorite={showFavorites}
                />
            ))}
        </div>
    );
}
